import * as forms from "@client/forms";
import * as router from "@client/router";
import {server} from "@reactivated";
import * as React from "react";

export const InviteUser = router.InviteUser.withHooks(() => {
    return {
        form: forms.useForm(server.core.rpc.InviteUser),
    };
})
    .withIndex((props) => (
        <div style={{display: "flex", gap: 15, flexDirection: "column"}}>
            <p>
                Just enter an email address below and we'll send instructions to the
                person you invited!
            </p>
            <forms.Field field={props.form.fields.email} />
        </div>
    ))
    .withActions((props) => [
        {
            icon: "send",
            title: "Invite",
            onClick: async () => {
                const response = await forms.submitForm(
                    props.form,
                    server.core.rpc.invite_user,
                );
                if (response?.type === "success") {
                    props.notify(
                        "Your invitation was sent! Feel free to invite other users.",
                    );
                    props.form.reset();
                    void props.analytics.track("INVITE_USER_SUCCESS");
                }
            },
        },
    ])
    .withOptions(() => ({
        title: "Invite user",
    }));
